/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Registration_Status_ApprovedInputs */

const en_admin_registration_status_approved = /** @type {(inputs: Admin_Registration_Status_ApprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approved`)
};

const de_admin_registration_status_approved = /** @type {(inputs: Admin_Registration_Status_ApprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genehmigt`)
};

/**
* | output |
* | --- |
* | "Approved" |
*
* @param {Admin_Registration_Status_ApprovedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_registration_status_approved = /** @type {((inputs?: Admin_Registration_Status_ApprovedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Registration_Status_ApprovedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_registration_status_approved(inputs)
	return en_admin_registration_status_approved(inputs)
});